export default __webpack_public_path__ + "problemManagementIcon2.png";